import { CSV_DELIMITER } from './constants';

export const processJsonResponse = (responseDataText) => {
  let noDataToDownload = false;
  let processedDataForBlob = responseDataText;
  let finalBlobType = "application/json;charset=utf-8";

  try {
    const jsonData = JSON.parse(responseDataText);

    if (
      (Array.isArray(jsonData) && jsonData.length === 0) ||
      (typeof jsonData === 'object' && jsonData !== null && !Array.isArray(jsonData) && Object.keys(jsonData).length === 0)
    ) {
      noDataToDownload = true;
    } else if (typeof jsonData === 'object' && jsonData !== null && !Array.isArray(jsonData)) {
      const allValuesAreObjects = Object.values(jsonData).every(
        value => typeof value === 'object' && value !== null && !Array.isArray(value)
      );
      if (allValuesAreObjects) {
        noDataToDownload = true;
      } else {
        processedDataForBlob = JSON.stringify(jsonData, null, 2);
      }
    } else {
      processedDataForBlob = JSON.stringify(jsonData, null, 2);
    }
  } catch (e) {
    if (responseDataText.trim() === "") noDataToDownload = true;
    finalBlobType = "text/plain;charset=utf-8";
  }
  return { processedDataForBlob, noDataToDownload, finalBlobType };
};

export const processCsvResponse = (responseDataText, selectedEndpoint) => {
  let noDataToDownload = false;
  let processedDataForBlob = responseDataText;
  const finalBlobType = "text/csv;charset=utf-8";

  let lines = responseDataText.split(/\r?\n/).filter(line => line.trim() !== '');
  const cleanLine = (str) => str.trim();

  if (lines.length > 0) {
    if (selectedEndpoint === "Bulk Download") {
      const headerContent = cleanLine(lines[0]);
      if (headerContent) {
        const dataLines = lines.slice(1).filter(line => cleanLine(line) !== headerContent);
        lines = [lines[0], ...dataLines];
      }
    } else if (selectedEndpoint === "Dataset Volunteers") {
      if (lines.length > 1 && cleanLine(lines[1]) === cleanLine(lines[0])) {
        lines.splice(1, 1);
      }
    }
  }

  if (lines.length <= 1) {
    noDataToDownload = true;
  } else if (selectedEndpoint === "Dataset Volunteers" || selectedEndpoint === "Dataset Metadata") {
    const headerLineFromCsv = lines[0].trim();
    const headersFromCsv = headerLineFromCsv.split(CSV_DELIMITER).map(h => h.trim().toLowerCase());
    const typeColumnIndex = headersFromCsv.indexOf('type');

    if (typeColumnIndex !== -1) {
      let allDataRowsAreObjectType = true;
      for (let i = 1; i < lines.length; i++) {
        const cells = lines[i].trim().split(CSV_DELIMITER).map(cell => cell.trim());
        if (cells.length <= typeColumnIndex || cells[typeColumnIndex].toLowerCase() !== 'object') {
          allDataRowsAreObjectType = false;
          break;
        }
      }
      if (allDataRowsAreObjectType) {
        noDataToDownload = true;
      }
    }
  }

  if (!noDataToDownload) {
    processedDataForBlob = "\uFEFF" + lines.join('\n');
  }

  return { processedDataForBlob, noDataToDownload, finalBlobType };
};

export const processOtherResponse = (responseDataText, contentTypeHeader) => {
  let noDataToDownload = false;
  let finalBlobType = "application/octet-stream";

  if (responseDataText.trim() === "") {
    noDataToDownload = true;
    finalBlobType = "text/plain;charset=utf-8";
  } else if (contentTypeHeader) {
    const baseContentType = contentTypeHeader.split(';')[0].trim().toLowerCase();
    const hasCharset = contentTypeHeader.toLowerCase().includes('charset=');

    if (baseContentType === "text/plain") {
      finalBlobType = "text/plain;charset=utf-8";
    } else if (baseContentType.startsWith("text/") ||
      baseContentType === "application/xml" ||
      baseContentType === "application/xhtml+xml") {
      finalBlobType = hasCharset ? contentTypeHeader : `${baseContentType};charset=utf-8`;
    } else {
      finalBlobType = baseContentType;
    }
  }
  return { processedDataForBlob: responseDataText, noDataToDownload, finalBlobType };
};